export default {
    appName: "LanguageKnow",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.languageknow.com' : 'http://127.0.0.1:8000',
    localUserKey: "teacha_web_udt_mk",

    PAYSTACK_PUBLIC_KEY: process.env.NODE_ENV == 'production' ? "pk_live_1d4cace14951c35c870543f87bfe001cbe0d09d3" : "pk_test_2b5960ffe78a23b9fdedb96e2932ccb8088255a6",

}
